"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ShortcutManager = /** @class */ (function () {
    function ShortcutManager() {
    }
    //delete
    ShortcutManager.prototype.isDelete = function (event) {
        return event.key === "Delete" || event.key === "Backspace";
    };
    // save or update template
    ShortcutManager.prototype.isCtrlS = function (event) {
        return event.ctrlKey && event.code === "KeyS";
    };
    // select all
    ShortcutManager.prototype.isCtrlA = function (event) {
        return event.ctrlKey && event.code === "KeyA";
    };
    // copy
    ShortcutManager.prototype.isCtrlC = function (event) {
        return event.ctrlKey && event.code === "KeyC";
    };
    // paste
    ShortcutManager.prototype.isCtrlV = function (event) {
        return event.ctrlKey && event.code === "KeyV";
    };
    // redo
    ShortcutManager.prototype.isCtrlY = function (event) {
        return event.ctrlKey && event.code === "KeyY";
    };
    // cut
    ShortcutManager.prototype.isCtrlX = function (event) {
        return event.ctrlKey && event.code === "KeyX";
    };
    // nudge
    ShortcutManager.prototype.isArrowUp = function (event) {
        return event.code === "ArrowUp";
    };
    // nudge
    ShortcutManager.prototype.isArrowDown = function (event) {
        return event.code === "ArrowDown";
    };
    // nudge
    ShortcutManager.prototype.isArrowLeft = function (event) {
        return event.code === "ArrowLeft";
    };
    // nudge
    ShortcutManager.prototype.isArrowRight = function (event) {
        return event.code === "ArrowRight";
    };
    // modifier
    ShortcutManager.prototype.isShift = function (event) {
        return event.shiftKey;
    };
    // lineHeight--
    ShortcutManager.prototype.isAltDown = function (event) {
        return event.altKey && event.code === "ArrowDown";
    };
    // lineHeight++
    ShortcutManager.prototype.isAltUp = function (event) {
        return event.altKey && event.code === "ArrowUp";
    };
    // charSpacing++
    ShortcutManager.prototype.isAltRight = function (event) {
        return event.altKey && event.code === "ArrowRight";
    };
    // charSpacing--
    ShortcutManager.prototype.isAltLeft = function (event) {
        return event.altKey && event.code === "ArrowLeft";
    };
    // redo
    ShortcutManager.prototype.isCtrlShiftZ = function (event) {
        return event.ctrlKey && event.shiftKey && event.code === "KeyZ";
    };
    // undo
    ShortcutManager.prototype.isCtrlZ = function (event) {
        return event.ctrlKey && !event.shiftKey && event.code === "KeyZ";
    };
    // zoom reset
    ShortcutManager.prototype.isCtrlOne = function (event) {
        return event.ctrlKey && event.key === "1";
    };
    // zoom in
    ShortcutManager.prototype.isCtrlMinus = function (event) {
        return event.ctrlKey && event.key === "-";
    };
    // zoom out
    ShortcutManager.prototype.isCtrlEqual = function (event) {
        return event.ctrlKey && event.key === "=";
    };
    // zoom to fit
    ShortcutManager.prototype.isCtrlZero = function (event) {
        return event.ctrlKey && event.key === "0";
    };
    return ShortcutManager;
}());
exports.default = new ShortcutManager();
//# sourceMappingURL=shourcutsManager.js.map